import { define } from "../preactement/define";
import { Review } from "../../Review";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['class-name', 'edit-aria-label', 'edit-href', 'edit-text', 'heading', 'heading-level'];
const Wrapper = _ref => {
  let {
    children,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(Review, {
    ...otherProps,
    children: children
  });
};

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

define('ds-review', () => Wrapper, {
  attributes: attributes,
  shadow: true
});